import { render, staticRenderFns } from "./authorityOperationModal.vue?vue&type=template&id=043aece0&scoped=true&"
import script from "./authorityOperationModal.vue?vue&type=script&lang=ts&"
export * from "./authorityOperationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043aece0",
  null
  
)

export default component.exports